/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_3_ProblemInputs */

const et_portfolio_project_3_problem = /** @type {(inputs: Portfolio_Project_3_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Väike turunduseelarve ja veebileht, mis ei muutnud külastajaid ostjateks.`)
};

const en_portfolio_project_3_problem = /** @type {(inputs: Portfolio_Project_3_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low marketing budget and a website that wasn’t converting visitors into buyers.`)
};

/**
* | output |
* | --- |
* | "Low marketing budget and a website that wasn’t converting visitors into buyers." |
*
* @param {Portfolio_Project_3_ProblemInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_3_problem = /** @type {((inputs?: Portfolio_Project_3_ProblemInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_3_ProblemInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_3_problem(inputs)
	return en_portfolio_project_3_problem(inputs)
});